import cnLocal from './cn';
import jaLocal from './en';
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN';// element-ui lang
import elementEnLocale from 'element-ui/lib/locale/lang/en';// element-ui lang

export default {
    cn: {
        ...cnLocal,
        ...elementZhLocale,
    },
    en: {
        ...jaLocal,
        ...elementEnLocale,
    },
};
